import { ADD_FEATURED_DARE } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth'

import addFeaturedDarePayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/addOrDeleteFeaturedDarePayloadSchema'
import { recordEndpointType } from 'root/src/shared/descriptions/endpoints/lenses'
import { project } from 'root/src/shared/descriptions/endpoints/recordTypes'
import projectResponseSchema from 'root/src/shared/descriptions/endpoints/schemas/responseSchemas/projectResponseSchema'
import { VALIDATE_TOKEN_ACCOUNT } from 'root/src/shared/descriptions/middlewares/middlewareIds'

export const payloadSchema = addFeaturedDarePayloadSchema
export const responseSchema = projectResponseSchema

export default {
	[ADD_FEATURED_DARE]: {
		endpointType: recordEndpointType,
		recordType: project,
		authentication: authenticationTypes.authenticated,
		authenticationRole: userGroups.admin,
		payloadSchema,
		responseSchema,
		middlewares: [VALIDATE_TOKEN_ACCOUNT],
	},
}
